module.exports = __webpack_public_path__ + "img/title.554abe76.jpg";